import { useTranslation } from "react-i18next";

function LoadingScreen() {
  const { t } = useTranslation();

  return (
    <div className="flex h-screen items-center justify-center text-2xl">
      <div>{t("loading")}</div>
    </div>
  );
}

export default LoadingScreen;
